import React from 'react';
import { Form, Radio, Button, Icon, Modal } from 'semantic-ui-react';
import ResponsiveDateInput from '../componentsHelpers/ResponsiveDateInput';

import styled from 'styled-components';
import { ErrorMessage } from 'formik';

import FormikInputField from '../componentsFormik/FormikInputField';
//import FormikSelectField from "../componentsFormik/FormikSelectField";
import PJModal from '../componentsHelpers/Modal';

import { getEmail } from '../api/request';

// const optsTitle = [
//     { key: 'Mr', text: 'Mr', value: 'Mr' },/
//     { key: 'Mrs', text: 'Mrs', value: 'Mrs' },
//     { key: 'Ms', text: 'Ms', value: 'Ms' },
//     { key: 'Miss', text: 'Miss', value: 'Miss' },
// ];

// const optsGender = [
//     { key: 'Female', text: 'Female', value: 'Female' },
//     { key: 'Male', text: 'Male', value: 'Male' },
// ];

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class PersonalDetailsForm extends React.Component<any, any> {

  state = { modalOpen: false, modalSize: 'mini', modalContent: null }

  showModal = (modalSize: any) => () => this.setState({ modalSize, modalOpen: true });

  closeModal = () => this.setState({ modalOpen: false, modalContent: null });

  prev = (e: any) => {
    e.preventDefault();
    this.props.prevStep();
  };

  next = (e: any) => {
    e.preventDefault();
    this.props.submitForm().then(() => {
      if (this.props.isValid) {
        this.emailCheck(this.props.values.stp4_emailAddress)
          .then(() => {
            this.props.gaEvent('event', 'PersonalInformation', 'Next', 'Boots', this.props.isValid);
            this.props.nextStep(this.props);
          })
          .catch((res) => { console.log(res); })
      }
    });
  };

  emailCheck = (emailAddress: string) => {
    return new Promise((resolve, reject) => {
      this.setState({ modalOpen: true, modalContent: this.modalContent('Just a second...', '', true, false) });
      getEmail(emailAddress)().then((response) => {
        if (response) {
          this.setState({
            modalContent: this.modalContent('We already have your email address :-)', 'It looks like your email address is already on our database. You will be redirected to our contact page when you click OK', false, true)
          });
          reject('email already exists');
        }
      }).catch(error => {
        if (error) {
          this.setState({ modalOpen: false, modalContent: null });
          resolve('all good, lets continue');
        }
      });
    });
  };

  handleChangePersist = (e: any) => {
    e.persist();
    this.props.handleChange(e);
  };

  clicked = (e: any) => {
    e.preventDefault();
    this.closeModal();
    window.location.replace("https://payjustice.co.uk/");
  }

  modalContent = (title: string, msg?: string, spinner?: boolean, btn?: boolean) => {
    return (
      <React.Fragment>
        <Modal.Header style={{ textAlign: 'center' }}>{title}</Modal.Header>
        <Modal.Content style={{ textAlign: 'center' }}>
          {spinner ? <Icon loading name='spinner' size='massive' /> : null}
          {msg ? <p>{msg}</p> : null}
        </Modal.Content>
        {btn ? <Modal.Actions style={{ textAlign: 'center' }}>
          <Button onClick={this.clicked} positive icon='checkmark' labelPosition='right' content='OK' />
        </Modal.Actions> : null
        }
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <PJModal
          size={this.state.modalSize}
          open={this.state.modalOpen}
          /* onClose={this.closeModal} */
          content={this.state.modalContent}
        />

        <Form.Group grouped>
          <label>Title</label>
          <Form.Field>
            <Radio
              label="Mr"
              name="stp4_title"
              value="Mr"
              checked={this.props.values.stp4_title === 'Mr'}
              onChange={() => this.props.setFieldValue('stp4_title', 'Mr')}
              data-testid="pd-radio-mr"
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="Mrs"
              name="stp4_title"
              value="Mrs"
              checked={this.props.values.stp4_title === 'Mrs'}
              onChange={() => this.props.setFieldValue('stp4_title', 'Mrs')}
              data-testid="pd-radio-mrs"
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="Ms"
              name="stp4_title"
              value="Ms"
              checked={this.props.values.stp4_title === 'Ms'}
              onChange={() => this.props.setFieldValue('stp4_title', 'Ms')}
              data-testid="pd-radio-ms"
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="Miss"
              name="stp4_title"
              value="Miss"
              checked={this.props.values.stp4_title === 'Miss'}
              onChange={() => this.props.setFieldValue('stp4_title', 'Miss')}
              data-testid="pd-radio-miss"
            />
          </Form.Field>
          <ErrorMessage
            name={'stp4_title'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        {/* <FormikSelectField
                    name="stp4_title"
                    label="Title"
                    placeholder="Title"
                    options={optsTitle}
                /> */}

        <FormikInputField
          name="stp4_firstName"
          type="input"
          label="First Name"
          placeholder="First Name"
          data-testid="pd-input-first-name"
        />

        <FormikInputField
          name="stp4_lastName"
          type="input"
          label="Last Name"
          placeholder="Last Name"
          data-testid="pd-input-last-name"
        />

        <FormikInputField
          name="stp4_emailAddress"
          type="input"
          label="Email Address"
          placeholder="Email Address"
          data-testid="pd-input-email-address"
        />

        <FormikInputField
          name="stp4_telephone"
          type="input"
          label="Telephone"
          placeholder="0207 123 4567"
          data-testid="pd-input-telephone"
        />

        <Form.Group grouped>
          <ResponsiveDateInput
            isMobile={(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))}
            name="stp4_dob"
            label="Date of Birth"
            id="stp4_dob"
            setFieldValue={this.props.setFieldValue}
            values={this.props.values}
            dataTestid="pd-input-dob"
            onBlur={this.props.handleBlur}
          />
          <ErrorMessage
            name={'stp4_dob'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        {/* <FormikCustomSelect
                    value={this.props.values.topics}
                    onChange={this.props.setFieldValue}
                    onBlur={this.props.setFieldTouched}
                    error={this.props.errors.topics}
                    touched={this.props.touched.topics}
                /> */}

        {/* 
                <FormikSelectField
                    name="stp4_gender"
                    label="Gender"
                    placeholder="Gender"
                    options={optsGender}
                /> */}

        <Form.Group grouped>
          <label>Gender</label>
          <Form.Field>
            <Radio
              label="Female"
              name="stp4_gender"
              value="Female"
              checked={this.props.values.stp4_gender === 'Female'}
              onChange={() => this.props.setFieldValue('stp4_gender', 'Female')}
              data-testid="pd-radio-female"
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="Male"
              name="stp4_gender"
              value="Male"
              checked={this.props.values.stp4_gender === 'Male'}
              onChange={() => this.props.setFieldValue('stp4_gender', 'Male')}
              data-testid="pd-radio-male"
            />
          </Form.Field>
          <ErrorMessage
            name={'stp4_gender'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <FormikInputField
          name="stp4_nationalInsurance"
          type="input"
          label="NI Number (not required but may speed up claim)"
          placeholder="QQ 12 34 56 C"
          data-testid="pd-input-ni"
        />

        <Button.Group widths="2">
          <Button
            labelPosition="left"
            floated="left"
            color="grey"
            icon="left chevron"
            content="Back"
            onClick={this.prev}
            data-testid="pd-button-back"
          />
          <Button
            labelPosition="right"
            floated="right"
            color={this.props.isValid ? 'green' : 'grey'}
            icon="right chevron"
            content="Next"
            onClick={this.next}
            data-testid="pd-button-next"
          />
        </Button.Group>
      </React.Fragment>
    );
  }
}

export default PersonalDetailsForm;
